import {IInvitation} from '../../interfaces/invitation.interface';
import {IUser} from '../../interfaces/user.interface';
import {ITeamRecord} from '../../../team/interfaces/team-record.interface';
import {IWholesalerConnection} from '../../interfaces/wholesaler-integration.interface';
import { IIntegrationConfiguration } from '../../interfaces/integration.interface';

export class SubscribeToPharmacyManagementSystem {
  static readonly type = '[Profile] Subscribe to the chosen pharmacy management system';

  constructor(public connectionData: IIntegrationConfiguration) {
  }
}

export class TestPharmacyManagementSystemConnection {
  static readonly type = '[Profile] test connection to the chosen pharmacy management system';

  constructor(public connectionData: IIntegrationConfiguration) {
  }
}

export class GetPharmacyManagementSystems {
  static readonly type = '[Profile] get pharmacy management system for the pharmacy';

  constructor() {
  }
}

export class SetPharmacyManagementSystemIntegrationConnectionStatus {
  static readonly type = '[Profile] set the Integration active or inactive by id';

  constructor(
    public id: string,
    public setActive: boolean,
  ) {
  }
}


export class GetUserTeamList {
  static readonly type = '[Profile] get user team list';

  constructor(public status?: string) {
  }
}

export class SetUserTeamList {
  static readonly type = '[Profile] set user team list for sorting purposes';

  constructor(public teamList: ITeamRecord[]) {
  }
}

export class GetDashboardInfo {
  static readonly type = '[Profile] get dashboard info at the top';
}

export class GetStates {
  static readonly type = '[Profile] get list of states';

  constructor() {
  }
}

export class GetWholesalersList {
  static readonly type = '[Profile] get list of wholesalers';

  constructor(public limitToPharmacy: boolean = false) {
  }
}

export class GetWholesalersFullList {
  static readonly type = '[Profile] get full list of wholesalers';

  constructor() {
  }
}


export class CreateWholesaler {
  static readonly type = '[Profile] create wholesaler';

  constructor(public name: string) {
  }
}

export class SetPharmacySelectedWholesaler {
  static readonly type = '[Profile] set pharmacy selected wholesaler';

  constructor(public wholesaler: IWholesalerConnection) {
  }
}

export class FilterWholesalers {
  static readonly type = '[Profile] filter wholesalers list by token';

  constructor(public token: string) {
  }
}

export class GetAvailableWholesalersList {
  static readonly type = '[Profile] get list of available wholesalers excluding connectionId';

  constructor(public connectionId: string) {
  }
}

export class RunWholesalerIntegration {
  static readonly type = '[Profile] run the wholesaler by id';

  constructor(public wholesaler: IWholesalerConnection) {
  }
}

export class CloseRunningWholesalerMessage {
  static readonly type = '[Profile] stay in process but hide a message';
}

export class SetWholesalerConnectionActive {
  static readonly type = '[Profile] set the wholesaler active or inactive by id';

  constructor(
    public id: string,
    public setActive: boolean,
  ) {
  }
}

export class RemoveWholesaler {
  static readonly type = '[Profile] remove the wholesaler by id';

  constructor(public id: number) {
  }
}

export class TestWholesalerConnection {
  static readonly type = '[Profile] test connection to the chosen wholesaler';

  constructor(public connectionData: IWholesalerConnection) {
  }
}

export class GetAllWholesalerConnections {
  static readonly type = '[Profile] get all wholesaler connections';

  constructor() {
  }
}

export class SaveWholesalerConnection {
  static readonly type = '[Profile] save connection to the chosen wholesaler';

  constructor(public connectionData: IWholesalerConnection) {
  }
}

export class EditWholesalerConnection {
  static readonly type = '[Profile] edit connection to the chosen wholesaler';

  constructor(public connectionData: IWholesalerConnection) {
  }
}

export class RemoveWholesalerConnection {
  static readonly type = '[Profile] remove connection by id';

  constructor(public id: string) {
  }
}

export class SignWithPIN {
  static readonly type = '[Profile] apply commitment using PIN';

  constructor(public request: any) {
  }
}

export class SaveAccountPIN {
  static readonly type = '[Profile] save user PIN';

  constructor(public pin: string) {
  }
}

export class UpdateAccountPIN {
  static readonly type = '[Profile] update user PIN';

  constructor(public pin: string) {
  }
}

export class CheckPinValidity {
  static readonly type = '[Profile] get status for entered PIN';

  constructor(public pin: any) {
  }
}

export class CheckPinBelongsToUser {
  static readonly type = '[Profile] check pin is valid and belongs to specified user';

  constructor(public pin: string | number) {
  }
}

export class SendInvitation {
  static readonly type = '[Profile] send invitations to users emails';

  constructor(public users: IInvitation[]) {
  }
}

export class EditTeammate {
  static readonly type = '[Profile] edit chosen teammate';

  constructor(public user: IUser) {
  }
}

export class ResendUserInvitation {
  static readonly type = '[Profile] resend invitation to chosen teammate';

  constructor(public email: string) {
  }
}

export class RevokeUserInvitation {
  static readonly type = '[Profile] revoke invitation of chosen teammate';

  constructor(public email: string) {
  }
}

export class DeleteUser {
  static readonly type = '[Profile] delete chosen teammate';

  constructor(public email: string) {
  }
}

export class UpdateUser {
  static readonly type = '[Profile] update chosen profile';

  constructor(public user: IUser) {
  }
}

export class GetUserNotifications {
  static readonly type = '[Profile] get user notifications';

  constructor(public customerId: string) {
  }
}

export class ClearAllNotifications {
  static readonly type = '[Profile] clear user notifications';
}

export class LoadMoreNotifications {
  static readonly type = '[Profile] load user notifications';
}

export class ResetProfileSuccess {
  static readonly type = '[Profile] reset status of response';
}

export class GetBeaconSignature {
  static readonly type = '[Profile] Get Beacon Signature';
}